import axios, { type AxiosError } from "axios";

const API_URL = import.meta.env.VITE_PUBLIC_API_URL ?? "http://localhost:3001";

export const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

// The API refreshes expired tokens transparently, so a 401 here means the
// session is unrecoverable. /auth/me is exempt because it is also used to
// check whether a visitor is logged in at all.
api.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (
      error.response?.status === 401 &&
      error.config?.url !== "/auth/me" &&
      typeof window !== "undefined"
    ) {
      window.location.href = "/login";
    }
    return Promise.reject(error);
  },
);
